// extracted by mini-css-extract-plugin
module.exports = {"TitleCategorization":"styles_TitleCategorization__276Gl"};